var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" }, attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [
        _vm._v(" " + _vm._s(_vm.$ct("common.settings")) + " "),
      ]),
      _c(
        "w-scroll-view",
        {
          style: { overflow: "hidden", minHeight: "400px" },
          attrs: { tag: "w-card-content", "no-padding": "" },
        },
        [
          _c("w-tabs", {
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
          _vm.tab == 0
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("common.title") },
                        model: {
                          value: _vm.data.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "title", $$v)
                          },
                          expression: "data.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-book-year", {
                        attrs: {
                          decimals: 0,
                          label: _vm.$ct("bookyear-override-optional"),
                          "add-previous-book-year-option": "",
                          "add-selected-book-year-option": "",
                        },
                        model: {
                          value: _vm.data.bookYearOverride,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "bookYearOverride", $$v)
                          },
                          expression: "data.bookYearOverride",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.tab == 1
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-human-filter-list-edit", {
                        attrs: { model: _vm.saleModel, browse: _vm.saleBrowse },
                        model: {
                          value: _vm.data.incomeFilters,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "incomeFilters", $$v)
                          },
                          expression: "data.incomeFilters",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-human-filter-list-edit", {
                        attrs: {
                          model: _vm.purchaseModel,
                          browse: _vm.purchaseBrowse,
                        },
                        model: {
                          value: _vm.data.costFilters,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "costFilters", $$v)
                          },
                          expression: "data.costFilters",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }